import { render, staticRenderFns } from "./powerList.vue?vue&type=template&id=0c97c67a&scoped=true"
import script from "./powerList.vue?vue&type=script&lang=js"
export * from "./powerList.vue?vue&type=script&lang=js"
import style0 from "./powerList.vue?vue&type=style&index=0&id=0c97c67a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c97c67a",
  null
  
)

export default component.exports